export const initialTrackIds = [
  "190IqlryWu91WBKeDgZqZz", //
  "1ZBqJilDGBVYktvlCEo9jC", //
  "3k3NWokhRRkEPhCzPmV8TW", //
  "2X485T9Z5Ly0xyaghN73ed", //
  "1JekRMGQ8iN4G1AAdh0SBa", //
  "1NZs6n6hl8UuMaX0UC0YTz",
];

export const initialAlbumIds = [
  "0DZPvNS2UafM6bBPMm3QEX",
  "6Um1E2xPQua8kP1tLT01PG",
  "51ABCq7no09mPcnuPY7kP2",
  '5L5evi5tJPh8WaEFAQp7Tp',
  '2MHUaRi9OCyTN02SoyRRBJ',
  '7oGejxIa9yVGrUvwt74OPU'
];
